module.exports = __webpack_public_path__ + "c8b3b1bd5d058fea60ee014da555766e.png";